import type { ExperienceAtfCardConfig, ExperienceAtfPromoVariant } from '~/features/experience/constants';
import {
  type BackToSchool2026Phase2Variant,
  BTS_2026_P2_VARIANTS,
  getBts2026Phase2CheckoutHref,
} from '~/features/promotions/constants/back-to-school-2026-phase-2-sale';

const BTS_2026_P2_ATF_PROMO_VARIANT: Record<BackToSchool2026Phase2Variant, ExperienceAtfPromoVariant> = {
  g1: 'bts_2026_p2_g1',
  g2: 'bts_2026_p2_g2',
};

/**
 * `/experience` ATF card for phase 2 (Figma 1944:1370 G1, 1944:1392 G2). Unlike phase 1 this design
 * leads with an "ENDS SOON" eyebrow and a single-line headline. Kept out of `surfaces.tsx` so the
 * card contract stays unit-testable without pulling in the JSX surfaces.
 */
export function buildBackToSchool2026Phase2ExperienceCard(
  resolved: BackToSchool2026Phase2Variant,
  promoCode?: string | null
): ExperienceAtfCardConfig {
  const config = BTS_2026_P2_VARIANTS[resolved];
  const promoVariant = BTS_2026_P2_ATF_PROMO_VARIANT[resolved];

  return {
    id: promoVariant,
    promoVariant,
    eyebrow: config.experienceAtfEyebrow,
    title: config.experienceAtfHeadline,
    description: config.experienceAtfDescription,
    ctaLabel: config.experienceAtfCtaLabel,
    action: {
      type: 'link',
      href: getBts2026Phase2CheckoutHref(resolved, promoCode),
    },
  };
}
